const Label = ({ title, value }) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string') {
    value = capitalize(value);
  }
  return (
    <div className="label">
      <label className="bold">{title}:</label>
      <p>{value}</p>
    </div>
  );
}

export default Label;

const capitalize = (string) => {
  return `${string[0].toUpperCase()}${string.slice(1)}`;
}
